export const SET_TEST_CASES = 'SET_TEST_CASES';
export const SET_TEST_CASES_COMPLETED = 'SET_TEST_CASES_COMPLETED';
export const SET_HAS_RUN_STARTED = 'SET_HAS_RUN_STARTED';

export const SET_WEBSOCKET_CONNECTION = 'SET_WEBSOCKET_CONNECTION';
export const SET_WEBSOCKET_MESSAGE = 'SET_WEBSOCKET_MESSAGE';

export const UPDATE_TEST_CASE = 'UPDATE_TEST_CASE';
export const SET_TEST_CASES_STATUS = 'SET_TEST_CASES_STATUS';
export const SET_CONSENT_URLS = 'SET_CONSENT_URLS';
export const TOGGLE_ROW_DETAILS = 'TOGGLE_ROW_DETAILS';

export const ADD_TOKEN_ACQUIRED = 'ADD_TOKEN_ACQUIRED';
export const SET_ALL_TOKENS_ACQUIRED = 'SET_ALL_TOKENS_ACQUIRED';
